import { useNavigate, useLocation } from 'react-router-dom'
import useRequest, { RequestTypes } from '../../../hooks/useRequest'
import useMount from '../../../hooks/useMount'
import debounce from 'lodash/debounce'

import style from './style.m.less'
import { Table, Tabs } from 'antd'
import ControlsBlock from '../ControlsBlock/ControlsBlock'
import { useCallback, useEffect, useState } from 'react'
import { columns } from './columns'
import { AGTotal, GenerationAttributeItem, PaginatedList } from '../../types'
import GenerationAttributesHistory from '../GenerationAttributesHistory/GenerationAttributesHistory'
import {useFilters} from "../../../hooks";

const { TabPane } = Tabs

enum AGListTypes {
    Active = '0',
    Blocked = '1',
    Expired = '2',
}

export type Filters = {
    volume: string
    generator_id: string
    registered_at: string
    period: string
    type: AGListTypes
}

const DEFAULT_PAG = {
    page: 1,
    pageSize: 10,
}

const tabsList = [
    { label: 'АГ помесячно', key: '0' },
    { label: 'История АГ', key: '1' },
]

const innerTabsOptions = [
    { label: 'Активные', id: '0' },
    { label: 'Истек срок действия', id: '2' },
    { label: 'Заблокированные/неоплаченные', id: '1' },
]

const defaultFilters = {
    volume: '',
    generator_id: '',
    registered_at: '',
    expires_at: '',
    blocked_at: '',
    period: '',
    type: AGListTypes.Active
}

const GenerationAttributes = () => {
    const navigate = useNavigate()
    const location = useLocation();

    const [outerTab, setOuterTab] = useState(() => {
        if (localStorage.getItem('generation_attributes_outer_tab_key')) {
            return localStorage.getItem('generation_attributes_outer_tab_key')
        } else {
            localStorage.setItem('generation_attributes_outer_tab_key', tabsList[0].key)
            return tabsList[0].key
        }
    })

    // const [innerTab, setInnerTab] = useState(innerTabsOptions[0].label)
    const [innerTab, setInnerTab] = useState(() => {
        if (innerTabsOptions[Number(localStorage.getItem('generation_attributes_inner_tab_key'))]) {
            return innerTabsOptions[Number(localStorage.getItem('generation_attributes_inner_tab_key'))].label
        } else {
            localStorage.setItem('generation_attributes_inner_tab_key', '0')
            return innerTabsOptions[0].label
        }
    })

    const [filters, setFilters] = useFilters()
    // const [filters, setFilters] = useState<Filters>(() => {
    //     return {
    //         volume: '',
    //         generator_id: '',
    //         registered_at: '',
    //         period: '',
    //         type: innerTabsOptions.find((item) => item.label === innerTab)?.id as unknown as AGListTypes
    //     }
    // })

    // const [pagination, setPagination] = useState(DEFAULT_PAG)
    const [pagination, setPagination] = useState(() => {
        if (localStorage.getItem('generation_attributes_pagination')) {
            return JSON.parse(localStorage.getItem('generation_attributes_pagination'))
        } else {
            localStorage.setItem('generation_attributes_pagination', JSON.stringify(DEFAULT_PAG))
            return DEFAULT_PAG
        }
    })

    const [GOList, setGOList] = useState([])
    const [isLoadingNewData, setIsLoadingNewData] = useState(false)

    const {
        fetch: getAGList,
        isLoading: isLoadingGetAGList,
        result: AGList,
    } = useRequest<PaginatedList<GenerationAttributeItem>>({
        link: '/api/generation_attributes/v1/gas/ga/list',
        method: RequestTypes.get,
    })

    const {
        fetch: getAGTotal,
        isLoading: isLoadingGetAGTotal,
        result: AGTotalResult,
    } = useRequest<AGTotal>({
        link: '/api/generation_attributes/v1/gas/ga/total',
        method: RequestTypes.get,
    })

    const debouncedGetAGList = useCallback(
        debounce(
            (filters) =>
                getAGList({
                    getParams: {
                        offset: (pagination.page - 1) * pagination.pageSize,
                        limit: pagination.pageSize,
                        ...filters,
                    },
                }),
            300,
        ),
        [],
    )

    useEffect(() => {
        setIsLoadingNewData(true)
        debouncedGetAGList(filters)
    }, [filters])

    useEffect(() => {
        const mappedGoList = AGList?.list
            .map((item) => ({
                name: item.go_name,
                generator_id: item.generator_id,
            }))
            .filter(
                (value, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.generator_id === value.generator_id && t.name === value.name,
                    ),
            )
        setGOList(mappedGoList)
    }, [AGList])

    useMount(() => {
        getAGList({})
        getAGTotal({})
    })

    useEffect(() => {
        getAGList({
            getParams: {
                offset: (pagination.page - 1) * pagination.pageSize,
                limit: pagination.pageSize,
                ...filters,
            },
        })

        if (location.state && location.state.fromMenu) {
            localStorage.removeItem('generation_attributes_outer_tab_key')
            setOuterTab(tabsList[0].key)
            localStorage.removeItem('generation_attributes_inner_tab_key')
            setInnerTab(innerTabsOptions[0].label)
            setFilters(defaultFilters)
            localStorage.setItem('generation_attributes_pagination', JSON.stringify(DEFAULT_PAG))
            setPagination(DEFAULT_PAG)
            navigate(location.pathname, {state: {fromMenu: false}})
        }
    }, [pagination])

    const onChangeInnerTab = (option: string) => {
        const typeId = innerTabsOptions.find((item) => item.label === option)?.id

        setFilters(() => ({
            ...defaultFilters,
            type: typeId as unknown as AGListTypes
        }))
        setInnerTab(option)
        setPagination(DEFAULT_PAG)
        localStorage.setItem('generation_attributes_pagination', JSON.stringify(DEFAULT_PAG))


        let innerTabKey = '0'
        innerTabsOptions.map((item, index) => {
            if (item.label === option) {
                innerTabKey = String(index)
            }
        })
        localStorage.setItem('generation_attributes_inner_tab_key', innerTabKey)
    }

    const AGListWithGoNames = AGList?.list?.map((item) => ({
        ...item,
    }))

    const isBlockedShown = innerTab === innerTabsOptions[2].label

    return (
        <div className={style.mainWrapper}>
            <div className={style.mainHeader}>Мои атрибуты генерации</div>

            <div className={style.tabsWrapper}>
                <Tabs
                    defaultActiveKey={!(location.state && location.state.fromMenu) && localStorage.getItem('generation_attributes_outer_tab_key')
                        ? localStorage.getItem('generation_attributes_outer_tab_key')
                        : "0"
                    }
                    onChange={(activeKey) => {
                        setOuterTab(activeKey)
                        localStorage.setItem('generation_attributes_outer_tab_key', activeKey)
                        setInnerTab(innerTabsOptions[0].label)
                        localStorage.setItem('generation_attributes_inner_tab_key', '0')
                        setFilters(defaultFilters)
                        setPagination(DEFAULT_PAG)
                        localStorage.setItem('generation_attributes_pagination', JSON.stringify(DEFAULT_PAG))
                    }}
                    className={style.tabs}
                >
                    {tabsList.map(({ key, label }) => (
                        <TabPane tab={label} key={key}>
                            <></>
                        </TabPane>
                    ))}
                </Tabs>
            </div>

            <div>
                <div className={style.gaMetrics}>
                    <div className={style.gaMetricsInner}>
                        <div className={style.gaMetricItem}>
                            <div className={style.gaMetricItemLabel}>АГ в составе ЗИ</div>
                            <div className={style.gaMetricItemValue}>
                                {AGTotalResult?.green_tools_volume}
                            </div>
                        </div>
                        <div className={style.gaMetricItem}>
                            <div className={style.gaMetricItemLabel}>Свободные АГ</div>
                            <div className={style.gaMetricItemValue}>
                                {AGTotalResult?.free_volume}
                            </div>
                        </div>
                        <div className={style.gaMetricItem}>
                            <div className={style.gaMetricItemLabel}>
                                Заблокированные/неоплаченные АГ
                            </div>
                            <div className={style.gaMetricItemValue}>
                                {AGTotalResult?.locked_volume}
                            </div>
                        </div>
                    </div>
                </div>

                {outerTab === '0' && (
                    <div className={style.gaWrapper}>
                        <ControlsBlock
                            onChange={onChangeInnerTab}
                            currentOption={innerTab}
                            options={innerTabsOptions}
                            onChangeFilters={(filters) => {
                                setPagination(DEFAULT_PAG)
                                localStorage.setItem('generation_attributes_pagination', JSON.stringify(DEFAULT_PAG))
                                setFilters(filters)
                            }}
                            goList={GOList || []}
                            filters={filters}
                        />
                        <Table
                            style={{ marginTop: '24px' }}
                            dataSource={AGList ? AGListWithGoNames : []}
                            loading={isLoadingGetAGList}
                            columns={columns(isBlockedShown)}
                            rowClassName="tableRow"
                            onRow={(record) => ({
                                onClick: () => navigate('/generation-attributes/go/' + record.id),
                            })}
                            onChange={(tablePagination) =>
                                setPagination((prev) => {
                                    localStorage.setItem('generation_attributes_pagination', JSON.stringify({
                                        ...prev,
                                        page: tablePagination?.current || 1
                                    }))
                                    return ({
                                        ...prev,
                                        page: tablePagination?.current || 1,
                                    })
                                })
                            }
                            pagination={{
                                position: ['bottomLeft'],
                                pageSize: pagination.pageSize,
                                current: pagination.page,
                                showSizeChanger: (AGList?.total || 0) > 0,
                                total: AGList?.total || 0,
                                disabled: AGList?.total === 0,
                                onShowSizeChange: (current, size) =>
                                    setPagination((prev) => {
                                        localStorage.setItem('generation_attributes_pagination', JSON.stringify({
                                            ...prev,
                                            pageSize: size
                                        }))
                                        return ({
                                        ...prev,
                                        pageSize: size,
                                    })
                                }),
                            }}
                        />
                    </div>
                )}

                {outerTab === '1' && (
                    <div className={style.historyWrapper}>
                        <GenerationAttributesHistory />
                    </div>
                )}
            </div>
        </div>
    )
}

export default GenerationAttributes
